"use strict";

exports.__esModule = true;
exports.OpenReportActionFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _vimanaTypes = require("@vimana/vimana-types");
var _API = require("../../API");
var _LayoutSelector = require("../../ConfigurableLayout/LayoutSelector");
var _Core = require("../../Core");
var _ReportCollection = require("../../Report/ReportCollection");
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Controls for OpenReportAction
 */

var OpenReportActionFields = exports.OpenReportActionFields = function OpenReportActionFields(props) {
  var handleLayoutSelect = function handleLayoutSelect(selected) {
    var config = props.config,
      onChange = props.onChange;
    onChange(Object.assign({}, config, {
      reportID: selected.length > 0 ? selected[0].id : undefined
    }));
  };
  var _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "OpenReportActionFields.report.placeholder",
      defaultMessage: "Select Report"
    }) : _props$placeholder,
    reportID = props.config.reportID,
    position = props.position;
  return /*#__PURE__*/_react["default"].createElement(_ReportCollection.ReportCollection, null, function (collection) {
    return /*#__PURE__*/_react["default"].createElement(_API.CollectionSearcher, {
      collection: collection
    }, function (searcherProps) {
      return /*#__PURE__*/_react["default"].createElement(_Core.LoadingMediator, searcherProps, function (report) {
        var selected = reportID ? [reportID] : [];
        return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
          label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "OpenReportActionFields.report.label",
            defaultMessage: "Report"
          }),
          helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
            id: "OpenReportActionFields.report.helperText",
            defaultMessage: "The report to open."
          })
        }, /*#__PURE__*/_react["default"].createElement(_LayoutSelector.LayoutSelector, {
          items: report,
          selected: selected,
          placeholder: placeholder,
          width: 300,
          onSelect: handleLayoutSelect,
          position: position
        }));
      });
    });
  });
};